import * as types from './mutations-type'

export const setHasNext = ({commit}, payload) => {
    commit(types.HASNEXT, payload)
}

export const setRequestPayload = ({commit}, payload) => {
    commit(types.REQUEST_PAYLOAD, payload)
}

export const setTotalEmails = ({commit}, payload) => {
    commit(types.TOTALEMAILS, payload)
}

export const setTotalSpaceyEmails = ({commit}, payload) => {
    commit(types.TOTALSPACEYEMAILS, payload)
}

export const setResponsePayload = ({commit}, payload) => {
    commit(types.RESPONSE_PAYLOAD, payload)
}

export const setLastPage = ({commit}, payload) => {
    commit(types.LASTPAGE, payload)
}

export const setPerPage = ({commit}, payload) => {
    commit(types.PERPAGE, payload)
}

export const setPage = ({commit}, payload) => {
    commit(types.SETPAGE, payload)
}

export const setStartTime = ({commit}, payload) => {
    commit(types.STARTTIME, payload)
}
export const setSortingField = ({commit}, payload) => {
    commit(types.SORTING_FIELD, payload)
}
export const setSortingDirection = ({commit}, payload) => {
    commit(types.SORTING_DIRECTION, payload)
}

export const setEndTime = ({commit}, payload) => {
    commit(types.ENDTIME, payload)
}

export const setIsFromSearch = ({commit}, payload) => {
    commit(types.ISFROMSEARCH, payload)
}

export const setIsLoading = ({commit}, payload) => {
    commit(types.ISLOADING, payload)
}

export const updateStatus = ({commit}, payload) => {
    commit(types.UPDATESTATUS, payload)
}

export const updateFlag = ({commit}, payload) => {
    commit(types.UPDATEFLAG, payload)
}

export const updatePoints = ({commit}, payload) => {
    commit(types.UPDATEPOINTS, payload)
}

export const updateMark = ({commit}, payload) => {
    commit(types.UPDATEMARK, payload)
}

export const updateScore = ({commit}, payload) => {
    commit(types.UPDATESCORE, payload)
}
export const setTotalSpacey2019Emails = ({commit}, payload) => {
    commit(types.TOTALSPACEY2019EMAILS, payload)
}
export const setPageObjects = ({commit}, payload) => {
    commit(types.PAGING, payload)
}

export const setPagingDataFromDate = ({commit}, payload) => {
    commit(types.CURRENT_PAGE_EMAIL_FROM_EMAIL_DATE, payload)
}

export const setPagingDataFromMuid = ({commit}, payload) => {
    commit(types.CURRENT_PAGE_EMAIL_FROM_MUID, payload)
}

export const setRequestPanelist = ({commit}, payload) => {
    commit(types.REQUEST_PANELIST, payload)
}

export const setUpdateAll = ({commit}, payload) => {
    commit(types.UPDATE_ALL, payload)
}

export const setUpdateIDs = ({commit}, payload) => {
    commit(types.ID_TO_UPDATE, payload)
}

export const setUpdateObjects = ({commit}, payload) => {
    commit(types.UPDATE_OBJECTS, payload)
}

export const removeObjByMuid = ({commit}, payload) => {
    commit(types.REMOVE_UPDATE_OBJ, payload)
}

export const updateFlagByMuid = ({commit}, payload) => {
    commit(types.UPDATE_FLAG_BY_MUID, payload)
}

export const updatePointsByMuid = ({commit}, payload) => {
    commit(types.UPDATE_POINTS_BY_MUID, payload)
}

export const updateStatusByMuid = ({commit}, payload) => {
    commit(types.UPDATE_STATUS_BY_MUID, payload)
}

export const updateMarkByMuid = ({commit}, payload) => {
    commit(types.UPDATE_MARK_BY_MUID, payload)
}

export const setCompetiIds = ({commit}, payload) => {
    commit(types.COMPETI_IDS, payload)
}

export const setProductId = ({commit}, payload) => {
    commit(types.PRODUCT_ID, payload)
}

export const removeAllUpdateObj = ({commit}) => {
    commit(types.REMOVE_ALL_UPDATE_OBJECTS)
}

export const setUpdateObjectsEmpty = ({ commit }, payload) => {
    commit(types.REMOVE_ALL_UPDATE_OBJ, payload)
}
